import { ReactNode, useCallback } from 'react';

import { useSelector } from 'react-redux';

import { BlockNoteEditorComponent } from '@/components/atoms/Editors/BlockNoteEditor/BlockNoteEditor';
import { getGuidelinesEditorOverrides } from '@/components/atoms/Editors/BlockNoteEditor/config';
import useBrains from '@/hooks/useBrains';
import { useBrainVariables } from '@/hooks/useBrainVariables';
import { getPermissions } from '@/redux/permissions/selectors';
import { selectBrainId } from '@/redux/session/selectors';
import type { Dialog } from '@/shared/types/dialog';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

import { SystemGuidelineField } from '../../models';

type SystemEditorProps = {
  title?: ReactNode;
  fieldToSave: SystemGuidelineField;
  onEditorReady?: (editor: { getMarkdown: () => Promise<string> }) => void;
  onChange?: () => void;
  enabledTools?: string[];
  dialogs?: Dialog[];
  onNavigateToLocalTools?: () => void;
};

export const SystemGuidelineEditor = ({
  title,
  fieldToSave,
  onEditorReady,
  onChange,
  enabledTools,
  dialogs,
  onNavigateToLocalTools,
}: SystemEditorProps) => {
  const brainId = useSelector(selectBrainId);
  const canWrite = useSelector((state: RootState) =>
    getPermissions(state, 'brains', actions.WRITE)
  );
  const { brain, getStatus } = useBrains(brainId);
  const { contextVariables } = useBrainVariables();

  const saveSystemGuideline = useCallback(
    (_markdownToSave: string) => {
      if (!canWrite) {
        return;
      }
    },
    [canWrite]
  );

  if (getStatus === 'success') {
    return (
      <>
        {title}
        <BlockNoteEditorComponent
          onSave={saveSystemGuideline}
          initialMarkdown={brain.guidelines?.[fieldToSave]}
          dictionary={getGuidelinesEditorOverrides().dictionary}
          editable={canWrite}
          onEditorReady={onEditorReady}
          onChange={onChange}
          enabledTools={enabledTools}
          dialogs={dialogs}
          onNavigateToLocalTools={onNavigateToLocalTools}
          contextVariableOptions={contextVariables}
        />
      </>
    );
  }

  return null;
};
